// ClientsGroupAttendanceRegister.js
import React, { useEffect, useState } from "react";
import {
  collection,
  addDoc,
  onSnapshot,
  query,
  where,
  getDocs,
  orderBy,
  limit,
} from "firebase/firestore";
import { Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { db } from "../../firebase";
import GroupAttendanceModal from "../Misc/GroupAttendanceModal";

const NUM_SHIFTS = 11;

function ClientsGroupAttendanceRegister() {
  const [forms, setForms] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);

  useEffect(() => {
    async function prepopulateForm() {
      // Utilisation de la date du jour
      const today = new Date();
      const year = today.getFullYear();
      const month = ("0" + (today.getMonth() + 1)).slice(-2);
      const day = ("0" + today.getDate()).slice(-2);
      const todayStr = `${year}-${month}-${day}`;

      const formsCollection = collection(db, "groupAttendanceForms");
      // Vérifier s'il existe déjà un document pour aujourd'hui
      const q = query(formsCollection, where("date", "==", todayStr));
      const snapshot = await getDocs(q);
      if (snapshot.empty) {
        const defaultForm = {
          date: todayStr,
          attendances: Array.from({ length: NUM_SHIFTS }, () => ({})),
        };
        await addDoc(formsCollection, defaultForm);
      }
    }
    prepopulateForm();
  }, []);

  useEffect(() => {
    // const unsubscribe = onSnapshot(
    //   collection(db, "groupAttendanceForms"),
    //   (snapshot) => {
    //     const formsData = [];
    //     snapshot.forEach((docSnap) => {
    //       formsData.push({ id: docSnap.id, ...docSnap.data() });
    //     });

    //     const uniqueForms = [];
    //     const seenDates = new Set();
    //     formsData.forEach((form) => {

    //       if (form.date && !seenDates.has(form.date)) {
    //         seenDates.add(form.date);
    //         uniqueForms.push(form);
    //       }
    //     });

    //     uniqueForms.sort((a, b) => {
    //       if (!a.date) return 1;
    //       if (!b.date) return -1;
    //       return a.date.localeCompare(b.date);
    //     });
    //     setForms(uniqueForms);
    //   }
    // );

    const q = query(
      collection(db, "groupAttendanceForms"),
      orderBy("date", "desc"),
      limit(10) // <-- seulement 10 derniers jours
    );
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const formsData = snapshot.docs.map((docSnap) => ({
        id: docSnap.id,
        ...docSnap.data(),
      }));
      setForms(formsData);
    });

    return () => unsubscribe();
  }, []);

  const handleRowClick = (form) => {
    setSelectedForm(form);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedForm(null);
  };

  return (
    <div>
      <div style={{ fontSize: "14px" }}>Select the day under</div>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {/* {forms */}

          {forms.map((form) => (
            // .map((form) => (
            <TableRow
              key={form.id}
              hover
              style={{ cursor: "pointer" }}
              onClick={() => handleRowClick(form)}
            >
              <TableCell>{form.date}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {selectedForm && (
        <GroupAttendanceModal
          open={modalOpen}
          onClose={handleModalClose}
          formData={selectedForm}
        />
      )}
    </div>
  );
}

export default ClientsGroupAttendanceRegister;
